module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field free-drawing"
  }, [_c('label', {
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.label) + " "), (!_vm.required) ? _c('em', {
    staticClass: "optional"
  }, [_vm._v("optional")]) : _vm._e(), (_vm.required) ? _c('em', {
    staticClass: "required"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "draw-canvas-wrapper",
    on: {
      "click": _vm.canvasExport,
      "touchend": _vm.canvasExport
    }
  }, [_c('canvas', {
    staticClass: "draw-canvas",
    attrs: {
      "width": _vm.width,
      "height": _vm.height
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "draw-canvas-clear icon yule-icon-refresh",
    on: {
      "click": _vm.canvasClean
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "draw-canvas-navigation"
  }, [_c('div', {
    staticClass: "btn draw-canvas-navigation--left",
    class: {
      'is-disabled': !_vm.leftScrollable
    },
    on: {
      "click": function($event) {
        return _vm.scroll(-50)
      }
    }
  }, [_vm._v("left")]), _vm._v(" "), _c('div', {
    staticClass: "btn draw-canvas-navigation--right",
    class: {
      'is-disabled': !_vm.rightScrollable
    },
    on: {
      "click": function($event) {
        return _vm.scroll(50)
      }
    }
  }, [_vm._v("right")])]), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "validation-message"
  }, [_vm._v(_vm._s(_vm.$t(_vm.error)))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07258e05","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataInput/FreeDrawing.vue
// module id = 1803
// module chunks = 0